import { render, staticRenderFns } from "./ContentNotificationList.vue?vue&type=template&id=c1160c9c&"
import script from "./ContentNotificationList.vue?vue&type=script&lang=js&"
export * from "./ContentNotificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports